<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" title="The Big Book of Gross Stuff">
<div class="dedication">
<p>
<em>This book is dedicated to your digestive mucus. (After all, no one ever
                        gives it a proper “thank-you”!)</em>
</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?131b1055